export const getList = state => state.list;
export const getQuery = state => state.query;
export const getPaginationData = state => state.paginationData;
export const getLoading = state => state.loading;
